// Copie este arquivo para o frontend, por exemplo:
// src/Services/Api/authInterceptor.js

import Axios from 'axios';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../Firebase/firebaseConnection';
import { BASEURL } from '../../styles/utils';

let authReadyPromise;

function waitForFirebaseUser() {
  if (auth.currentUser) return Promise.resolve(auth.currentUser);

  if (!authReadyPromise) {
    authReadyPromise = new Promise((resolve) => {
      const unsubscribe = onAuthStateChanged(auth, (user) => {
        unsubscribe();
        resolve(user);
      });
    });
  }

  return authReadyPromise;
}

Axios.interceptors.request.use(async (config) => {
  const url = String(config.url || '');
  const method = String(config.method || 'get').toLowerCase();
  const mutatingMethods = ['post', 'put', 'patch', 'delete'];

  if (!url.startsWith(BASEURL) || !mutatingMethods.includes(method)) {
    return config;
  }

  const user = await waitForFirebaseUser();
  if (!user) return config;

  const idToken = await user.getIdToken();
  config.headers = config.headers || {};
  config.headers.Authorization = `Bearer ${idToken}`;

  return config;
});
